/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Modal, ModalBody, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IMfrmEmailSubscriptionModalViewProps } from './mfrm-email-subscription-modal';

export default (props: IMfrmEmailSubscriptionModalViewProps) => {
    const {
        isOpen,
        heading,
        subHeading,
        form,
        sucessMsgHeading,
        errorMsgHeading,
        disclosures,
        errorBlock,
        successContent,
        successCTA,
        errorCTA,
        emailValidationBlock,
        isSubscribeSuccessfully,
        isError,
        onCloseModal,
        enableShoppingIntentModal,
        shoppingIntentModal
    } = props;

    const emailModal = (
        <>
            <ModalHeader>
                    {<button type='button' data-cy='email-sign-up-modal-close' className='msc-modal__close-button' aria-label='Close' onClick={onCloseModal} />}
            </ModalHeader>
            <ModalBody className='modal-email-subscription__body'>
                    {/* subscription form */}
                    {!isSubscribeSuccessfully && !isError && (
                        <>
                            {subHeading}
                            {heading}
                            {form}
                            {emailValidationBlock}
                            {disclosures}
                        </>
                    )}
                    {/* Successfully subscribed state */}
                    {isSubscribeSuccessfully && (
                        <div className='modal-email-subscription__success'>
                            {sucessMsgHeading}
                            {successContent}
                            {successCTA}
                        </div>
                    )}
                    {/* Error state */}
                    {isError && (
                        <div className='modal-email-subscription__error'>
                            {errorMsgHeading}
                            {errorBlock}
                            {errorCTA}
                        </div>
                    )}
            </ModalBody>
        </>
    );

    return (
        <Modal
            autoFocus={true}
            fade={false}
            isOpen={isOpen}
            horizontalPosition={'center'}
            verticalPosition={'center'}
            zIndex={5003}
            toggle={onCloseModal}
            applicationNode={'rsg-root'}
            modalClassName={`modal-email-subscription ${enableShoppingIntentModal ? 'modal-shopping': ''}`}
        >
            {enableShoppingIntentModal ? shoppingIntentModal : emailModal}
        </Modal>
    );
};
